"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactBootstrap = require("react-bootstrap");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var DateInput = function DateInput(_ref) {
  var value = _ref.value,
      name = _ref.name,
      isInvalid = _ref.isInvalid,
      label = _ref.label,
      onChange = _ref.onChange,
      errors = _ref.errors,
      disabled = _ref.disabled,
      onClear = _ref.onClear,
      placeholder = _ref.placeholder,
      className = _ref.className,
      heightDateInput = _ref.heightDateInput,
      widthDateInput = _ref.widthDateInput,
      max = _ref.max,
      min = _ref.min;
  var dateInput = (0, _react.useRef)();

  var _useState = (0, _react.useState)(''),
      _useState2 = _slicedToArray(_useState, 2),
      formatValue = _useState2[0],
      setFormatValue = _useState2[1];

  var borderColor = isInvalid ? 'group-input-search border-search' : 'group-input-search';
  (0, _react.useEffect)(function () {
    setFormatValue(value ? value.split('T')[0].split('-').reverse().join('/') : null);
  }, [value]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "styleInput ".concat(className)
  }, label && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, null, label), /*#__PURE__*/_react.default.createElement(_reactBootstrap.InputGroup, {
    hasValidation: true,
    className: "container-input date-input mb-3",
    style: {
      width: widthDateInput
    }
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    ref: dateInput,
    type: "text",
    disabled: disabled,
    defaultValue: formatValue,
    name: name,
    isInvalid: isInvalid,
    placeholder: placeholder,
    style: {
      height: heightDateInput
    },
    autoComplete: "off",
    readOnly: true
  }), !disabled && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.InputGroup.Text, {
    className: "".concat(borderColor, " cursor-pointer content-date"),
    style: {
      height: heightDateInput
    }
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    type: "date",
    className: "space-input-date",
    value: value,
    name: name,
    onChange: onChange,
    min: min,
    max: max
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control.Feedback, {
    type: "invalid"
  }, errors))));
};

DateInput.propTypes = {
  value: _propTypes.default.string,
  name: _propTypes.default.string.isRequired,
  onChange: _propTypes.default.func,
  onClear: _propTypes.default.func,
  disabled: _propTypes.default.bool,
  isInvalid: _propTypes.default.bool,
  label: _propTypes.default.string,
  errors: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  className: _propTypes.default.string,
  heightDateInput: _propTypes.default.string,
  widthDateInput: _propTypes.default.string,
  max: _propTypes.default.string,
  min: _propTypes.default.string
};
DateInput.defaultProps = {
  disabled: false,
  isInvalid: false,
  onClear: function onClear() {},
  label: '',
  errors: '',
  placeholder: '',
  className: '',
  heightDateInput: '',
  widthDateInput: '',
  max: '',
  min: ''
};
var _default = DateInput;
exports.default = _default;